import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBar, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { OrderService } from 'src/app/services/order/order.service';

@Component({
  selector: 'app-editcustomer',
  templateUrl: './editcustomer.component.html',
  styleUrls: ['./editcustomer.component.scss']
})
export class EditcustomerComponent implements OnInit {
  customerForm: FormGroup;
  customerCode: string;
  customerName: string;
  customerType: string;
  address: string;
  city: string;
  country: string;
  area: string;
  zone: string;
  contactPerson: string;
  phoneNo: Number;
  email: string;

  allZones = [];
  isDuplicateCustomerCode: boolean = false;
 
  constructor(
    private formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    public router: Router,
    public customerService: CustomerService,
    public orderservice: OrderService,
    private dialog : MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any


  ) {

    this.customerForm = formBuilder.group({
      'customerCode': [null],
      'customerName': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z_ ]+$")
      ]],
      'customerType': [null, [
        Validators.pattern('^[a-zA-Z0-9 ]*$')
      ]],
      'deliveryLocationType': [null,[
        Validators.required
      ]],
      'houseNumber': [null,[
        Validators.required,
      ]],
      'city': [null,
        [Validators.pattern("^[a-zA-Z_ ]+$")
        ]],
      'country': [null],
      'area': [null, [
        Validators.pattern("^[a-zA-Z0-9_ ]+$")
      ]],
      'zone': [null],
      'contactPerson': [null, [
        Validators.pattern("^[a-zA-Z_ ]+$")
      ]],
      'phoneNo': [null, [
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.pattern('^[0-9]*$')
      ]],
      'email': [null, [
        Validators.email]
      ],
      'pincode': [null, [
        Validators.required,
        Validators.pattern('^[0-9]*$')
      ]],
      'id': [null]
    });

  }
  openSnackBar(message) {
    let extraClasses;
    this.snackBar.open(message, 'ok', {
      duration: 2000,
      panelClass: ['extraClasses']
    });
  }

  ngOnInit() {
    this.orderservice.getZoneList().subscribe(zones => {
      this.allZones = zones;
      console.log(zones);
    });
    console.log("customerInfo",this.data);
      this.customerForm.patchValue({
        customerName: this.data.customerName,
        customerCode: this.data.customerCode,
        customerType: this.data.customerType,
        email: this.data.email,
        deliveryLocationType: this.data.deliveryLocationType,
        id: this.data.id,
        phoneNo: this.data.phoneNo,
        area: this.data.address.area,
        city: this.data.address.city,
        pincode: this.data.address.pincode,
        country: this.data.address.country,
        zone: this.data.address.zone,
        houseNumber: this.data.address.houseNumber,
        contactPerson: this.data.contactPerson
      })

      this.customerService.getAllCustomers().subscribe(allCustomers => {
        console.log("all",allCustomers);
        let allBU = []
        allCustomers.forEach(customer => {
          allBU.push(customer.bu);
        });
      });

  }

  editCustomer() {
    console.log("form value", this.customerForm.value);
    let address = {}
    address = {
      houseNumber : this.customerForm.value.houseNumber,
      area : this.customerForm.value.area,
      city: this.customerForm.value.city,
      pincode : this.customerForm.value.pincode,
      country: this.customerForm.value.country,
      zone: this.customerForm.value.zone
    }
    delete this.customerForm.value.houseNumber;
    delete this.customerForm.value.area;
    delete this.customerForm.value.city;
    delete this.customerForm.value.pincode;
    delete this.customerForm.value.country;
    delete this.customerForm.value.zone;

    this.customerForm.value.address = address;
    this.customerService.updateCustomer(this.customerForm.value).subscribe(customeradded => {
      console.log(customeradded);
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
      this.router.navigate(["/managecustomers"])); 
      this.dialog.closeAll();
    },Error => {
      console.log(Error);
    });
  }

  checkForDuplicateCode(event){
    console.log("function called",event.srcElement.value);
    if(event.srcElement.value!=this.data.customerCode){
    this.customerService.checkDuplicateCustomerCode(event.srcElement.value).subscribe(isAvailable=>{
      console.log(isAvailable);
      if(isAvailable){
          this.isDuplicateCustomerCode = true;
      }
      else
      this.isDuplicateCustomerCode = false;
    });
  }
  }
  typingCustomerCode(){
    this.isDuplicateCustomerCode = false;
  }
}
